import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'

export function uploadFile(data) {
    return http.request({
        url: common.url + '/papi/common/upload',
        method: 'post',
        data: data
    })
}
// 修改学员信息
export function updateUser(data) {
    return http.request({
        url:  common.url + '/papi/student/edits',
        method: 'put',
        data: data
    })
}
export function getMyHeaderImage() {
    return http.request({
        url:  common.url + '/papi/student/getMyHeaderImage',
        method: 'get',
    })
}
